import { h } from 'preact'

export default function({ title }) {
  return (
    <header className="conversion-step__header">
      <h2 className="conversion-step__header-title">{ title }</h2>
    </header>
  )
}
